import React, {useState} from 'react'
import {Link, withRouter} from "react-router-dom"
import {Breadcrumbs, FormControl, MenuItem, Select, Typography} from "@material-ui/core";
import HomeIcon from '@material-ui/icons/Home';
import {withStyles} from "@material-ui/core/styles";
import {connect} from "react-redux";
import {saveApiSelection} from "../../stores/ApiSelectionParam/ApiSelectionParamActions";
import '../../../assets/style/overview.scss'
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import AppBar from "@material-ui/core/AppBar";
import AsciiDoc from "../../components/AsciiDoc/AsciiDoc";
import OpenApiDoc from "../../components/OpenApiDoc/OpenApiDoc";
import {saveApiTabSelection} from "../../stores/ApiTabSelectionParam/ApiTabSelectionParamActions";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

const styles = theme => ({
    appBar: {
        boxShadow: "none",
        "& .MuiTab-root.Mui-selected": {
            color: '#55475B'
        },
        "& .MuiTabs-indicator": {
            backgroundColor: "#000000",
            height: "4px"
        },
    },
    selectPaper: {
        marginLeft: "-10px",
        marginTop: "5px"
    },
    formControl: {
        // minWidth: 120,
        "& .MuiOutlinedInput-input": {
            padding: "2px 0px"
        },
        "& .MuiPopover-paper": {
            top: "200px"
        }
    },
    tab: {
        minHeight: "65px",
        "& .MuiTab-wrapper": {
            marginTop: "15px",
            fontFamily: "MontSerrat",
            fontWeight: "600",
            color: "#55475B",
            fontSize: "17px"
        }
    },
    link: {
        display: 'flex',
        color: '#008577',
        '&:hover': {
            color: 'grey'
        },
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    breadcrumbs: {
        marginTop: "55px",
        marginLeft: "40px"
    },
    breadcrumbsText: {
        fontSize: "15px",
        color: "#000000"
    }
});

const Overview = (props) => {

    const {classes, apiSelection, apiTabSelection, saveApiTabSelection} = props;
    const [version, setVersion] = useState(Object.keys(apiSelection.versions)[Object.keys(apiSelection.versions).length - 1]);

    const handleVersionChange = (event) => {
        setVersion(event.target.value)
    }

    const handleDownloadClick = (api) => {
        const url = `${window.portalBaseUrl}/documentation/${Object.values(apiSelection.versions)[0].staticResource.documentation}`;
        window.open(url, '_blank').focus();
    }

    return (
        <div id={"overview-"}>
            <div style={{background: "#EFEEEF"}}>
                <div className={"breadcrumbs-container"}>
                    <Breadcrumbs className={classes.breadcrumbs} aria-label="breadcrumb">
                        <Link to={"/"} color="inherit" className={classes.link}>
                            <HomeIcon className={classes.icon}/>
                            <Typography className={classes.breadcrumbsText}>Home</Typography>
                        </Link>
                        <Link to={"/catalog"} color="inherit" className={classes.link}>
                            <Typography className={classes.breadcrumbsText}>API Catalog</Typography>
                        </Link>
                        <Typography className={classes.breadcrumbsText}>Account Information Services (AIS)</Typography>
                    </Breadcrumbs>
                </div>
                <div className={"api-overview-header-container"}>
                    <span className={"api-overview-header-title"}>{apiSelection.name}</span>
                    <div className={"api-overview-content-container-parent"}>
                        <div className={"api-overview-content-container-left"}>
                            <span className={"api-overview-content-left-framework"}>{apiSelection.framework}</span>
                            <span className={"api-overview-content-left-progress"}>{apiSelection.progress}</span>
                        </div>
                        <div className={"api-overview-content-container-right"}>
                            <button className="btn btn-small btn-green-hover"
                                    onClick={() => handleDownloadClick(apiSelection)}>
                                <span className={"link-text"}>Swagger</span>
                            </button>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <Select
                                    MenuProps={{
                                        classes: {paper: classes.selectPaper},
                                        anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        },
                                        transformOrigin: {
                                            vertical: 'top',
                                            horizontal: 'left',
                                        },
                                        getContentAnchorEl: null,
                                    }}
                                    style={{
                                        color: "white",
                                        backgroundColor: "#008577",
                                        fontWeight: "600",
                                        border: "unset"
                                    }}
                                    className={"btn btn-small btn-green-hover select"}
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    value={"default"}
                                    onChange={handleVersionChange}
                                >
                                    <MenuItem style={{display: "none"}} value={"default"} disabled><span
                                        style={{marginRight: "-8px"}}
                                        className={"link-text"}>version {version}<ArrowDropDownIcon
                                        style={{marginLeft: "2px"}}/></span></MenuItem>
                                    {
                                        Object.keys(apiSelection.versions).map((version) => {
                                            return <MenuItem key={crypto.randomUUID()} value={version}>version {version}</MenuItem>
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className={"api-overview-details-container"}>
                        {apiSelection && apiSelection.details && apiSelection.details.length > 0 ?
                            apiSelection.details.map((detail) => {
                                return <span key={crypto.randomUUID()} className={"api-overview-details-text"}>{detail}</span>
                            }) : null}
                    </div>
                </div>
            </div>
            <div style={{display: "flex"}}>
                <AppBar position="static" color="default" className={classes.appBar}>
                    <Tabs
                        style={{backgroundColor: "white"}}
                        value={apiTabSelection}
                        onChange={(event, newEvent) => saveApiTabSelection(newEvent)}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        centered
                    >
                        <Tab style={{borderBottom: "1px solid #000000"}} className={classes.tab} value={"Overview"}
                             label="Overview"/>
                        <Tab style={{borderBottom: "1px solid #000000"}} className={classes.tab} value={"Documentation"}
                             label="Documentation"/>
                    </Tabs>
                </AppBar>
            </div>

            {"Overview" === apiTabSelection ?
                <div style={{paddingTop: "50px"}} className="root-all bg-white">
                    <AsciiDoc
                        staticResource={`/documentation/${Object.values(apiSelection.versions)[0].staticResource.overview}`}
                        minusDocHeight={"400px"}/>
                </div>
                : <div>
                    <OpenApiDoc
                        staticResource={`/documentation/${Object.values(apiSelection.versions)[0].staticResource.documentation}`}/>
                </div>}

        </div>
    )
}

//// JS REDUX
const mapStateToProps = (state) => ({
    apiSelection: state.apiSelectionParam.apiSelection,
    apiTabSelection: state.apiTabSelectionParam.apiTabSelection
});

const mapDispatchToProps = {
    saveApiSelection,
    saveApiTabSelection
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(Overview)))

